import React, {useEffect} from 'react';
import PublicHomePage from "./PublicHomePage";

export default function WhyPage(props) {

    return <PublicHomePage why={true}/>
}